import { render, staticRenderFns } from "./selectoptions.vue?vue&type=template&id=dd0b072a"
import script from "./selectoptions.js?vue&type=script&lang=js&external"
export * from "./selectoptions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports